import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';

import TSTable, { DeleteButtonTableCell, SwitchTableCell, DateTableCell } from '@ts-core/components/Table';
import { TSTableColumn } from '@ts-core/components/Table/TSTable/TSTable';

import Box from '@mui/material/Box';

import { Exercise } from '../../types';
interface ExercisesTableProps {
  exercises?: Exercise[];
  loading?: boolean;

  onRemoveExercise: (exercise: Exercise) => void;
  onTogglePractice: (exercise: Exercise) => void;
  onEditExercise: (exercise: Exercise) => void;
  onSortExercises?: (from: number, to: number) => void;
}

const ExercisesTable = (props: ExercisesTableProps) => {
  const { exercises, loading, onRemoveExercise, onTogglePractice, onEditExercise, onSortExercises } = props;
  const intl = useIntl();

  const columns = useMemo((): TSTableColumn<Exercise>[] => {
    return [
      {
        Header: intl.formatMessage({ id: 'field.allowToPractice.label' }),
        accessor: 'forPractice',
        valueTransformer: (_id, _, exercise) => (
          <SwitchTableCell item={exercise} onChange={onTogglePractice} getValue={(exercise) => exercise.forPractice} />
        ),
      },
      {
        Header: intl.formatMessage({ id: 'field.exercise.code' }),
        accessor: 'code',
      },
      {
        Header: intl.formatMessage({ id: 'exercise.type' }),
        accessor: 'type',
        valueTransformer: (type) => (type === 'FillInTheBlanksExercise' ? 'Completar los blancos' : 'Múltiple Opción'),
      },
      {
        Header: intl.formatMessage({ id: 'createdAt' }),
        accessor: 'createdAt',
        valueTransformer: (value) => <DateTableCell date={value} />,
      },
      {
        Header: '',
        accessor: '_id',
        valueTransformer: (id, _, exercise) => (
          <Box display="flex" justifyContent="flex-end">
            <DeleteButtonTableCell
              message={intl.formatMessage(
                {
                  id: 'dialog.confirmRemoveItem.title',
                },
                { item: exercise.code }
              )}
              item={exercise}
              onConfirm={onRemoveExercise}
            />
          </Box>
        ),
      },
    ];
  }, [intl, onTogglePractice, onRemoveExercise]);

  return <TSTable loading={loading} columns={columns} data={exercises} onSelectRow={onEditExercise} onSortEnd={onSortExercises} />;
};

export default ExercisesTable;
